import { Navigate } from "react-router-dom";

import { Paths } from "@/core/constants/paths";
import { AppLayout } from "@/modules/global/layout";
import { ControlPanelPage } from "@/pages/control-panel";
import { AuditPage } from "@/pages/control-panel/audit";
import { PermissionsPage } from "@/pages/control-panel/permissions";
import { RolesPage } from "@/pages/control-panel/roles";
import { UsersPage } from "@/pages/control-panel/users";
import type { ExtendedRouteObject } from "./types";

/** Rotas administrativas — Painel de Controle e suas abas */
export const adminRoutes: ExtendedRouteObject[] = [
  {
    element: <AppLayout />,
    rules: ["user"],
    scope: ["workspace"],
    children: [
      {
        path: Paths.CONTROL_PANEL,
        element: <ControlPanelPage />,
        rules: ["user"],
        scope: ["workspace"],
        children: [
          {
            index: true,
            element: <Navigate to={Paths.CONTROL_PANEL_USERS} replace />,
          },
          {
            path: Paths.CONTROL_PANEL_PERMISSIONS,
            element: <PermissionsPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
          {
            path: Paths.CONTROL_PANEL_USERS,
            element: <UsersPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
          {
            path: Paths.CONTROL_PANEL_ROLES,
            element: <RolesPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
          {
            path: Paths.CONTROL_PANEL_AUDIT,
            element: <AuditPage />,
            rules: ["user"],
            scope: ["workspace"],
          },
        ],
      },
    ],
  },
];
